import { registerHandTarget } from '../tutorial/services/TutorialHandService';
import { PetController } from './PetController';

let pet: PetController | undefined;
export function getPet() {
  if (!pet) {
    throw new Error('Pet Controller not configured');
  }
  return pet;
}

export function isPetConfigured() {
  return !!pet;
}

export function setPet(controller: PetController) {
  if (pet && controller) {
    throw new Error('Pet Controller already defined');
  }
  pet = controller;
  // Tutorial v2 hand target for the pet
  registerHandTarget('buruburu', controller.entity.getView());
}

export function resetPet() {
  pet = undefined;
}

let friendsPet: PetController | null = null;
export function getFriendsPet() {
  return friendsPet;
}

export function setFriendsPet(controller: PetController | null) {
  if (friendsPet && controller) {
    throw new Error(`Friend's pet Controller already defined`);
  }
  friendsPet = controller;
}
